import { render, staticRenderFns } from "./changeDutyList.vue?vue&type=template&id=684ca6ae&scoped=true"
import script from "./changeDutyList.vue?vue&type=script&lang=js"
export * from "./changeDutyList.vue?vue&type=script&lang=js"
import style0 from "./changeDutyList.vue?vue&type=style&index=0&id=684ca6ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684ca6ae",
  null
  
)

export default component.exports